import { FaCheck } from "react-icons/fa";
import { Box, Flex } from "@chakra-ui/layout";
import { Steps } from "antd";
import colors from "core/resources/theme/colors";

interface StepperProps {
  current: number;
  onClickStep: (step: number) => any;
  steps: {
    title: string;
  }[];
}

function Stepper({ current, onClickStep, steps }: StepperProps) {
  const getBackgroundColorForStep = (stepNumber: number) => {
    if (stepNumber > current) {
      return colors.white;
    } else if (stepNumber === current) {
      return colors.primary;
    }
    return colors.green500;
  };

  const getColorForStep = (stepNumber: number) => {
    if (stepNumber > current) {
      return colors.primary;
    }
    return colors.white;
  };

  return (
    <Steps current={current}>
      {steps.map((step, index) => (
        <Steps.Step
          key={index}
          title={current === index ? step.title : undefined}
          icon={
            <Flex
              aria-label={`Passo ${step.title}`}
              role="Botão"
              onClick={index < current ? () => onClickStep(index) : undefined}
              cursor={index < current ? "pointer" : "auto"}
              opacity={index > current ? 0.5 : 1}
              borderColor={index < current ? colors.green500 : colors.primary}
              borderWidth={1}
              bg={getBackgroundColorForStep(index)}
              rounded="full"
              h={"32px"}
              w={"32px"}
              justifyContent="center"
              alignItems="center"
            >
              <Box as="span" color={getColorForStep(index)} fontSize={18}>
                {index < current ? (
                  <FaCheck size={18} color={colors.white} />
                ) : (
                  index + 1
                )}
              </Box>
            </Flex>
          }
        />
      ))}
    </Steps>
  );
}

export default Stepper;
